"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchElawsLoader = void 0;
const common_1 = require("./common");
const lawinfo_1 = require("../lawinfo");
const elawsApi_1 = require("../../elawsApi");
const fetchBaseLawInfosFromElaws = async () => {
    const lawNameList = await (0, elawsApi_1.fetchLawNameList)();
    return lawNameList.map(item => {
        const baseLawInfo = {
            LawID: item.LawId,
            LawNum: item.LawNo,
            LawTitle: item.LawName,
            Enforced: true,
            Path: item.LawId,
            XmlName: `${item.LawId}.xml`,
        };
        return baseLawInfo;
    });
};
class FetchElawsLoader extends common_1.Loader {
    async loadLawInfosStruct() {
        const baseLawInfos = await fetchBaseLawInfosFromElaws();
        const lawInfos = baseLawInfos.map(lawinfo_1.LawInfo.fromBaseLawInfo);
        const [lawInfosByLawnum, lawInfosByLawID] = (0, common_1.lawInfosToByLawnumAndID)(lawInfos);
        return { lawInfos, lawInfosByLawnum, lawInfosByLawID };
    }
    async loadBaseLawInfosFromCSV() {
        return fetchBaseLawInfosFromElaws();
    }
    async loadLawXMLStructByInfo(lawInfoOrLawIDOrLawNum) {
        return (0, elawsApi_1.fetchLawData)(typeof lawInfoOrLawIDOrLawNum === "string" ? lawInfoOrLawIDOrLawNum : lawInfoOrLawIDOrLawNum.LawID);
    }
}
exports.FetchElawsLoader = FetchElawsLoader;
exports.default = FetchElawsLoader;
//# sourceMappingURL=FetchElawsLoader.js.map